import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

// Auth Users
import Dashboard from "../../views/Dashboard/Dashboard";
import AccountManagement from "../../views/AccountManagement/AccountManagement";
import PageNotFound from "../../views/Errors/404Error";
import Setting from "../../views/SettingManagement/setting";
// import Login from "../../views/Login/Login";
// import Signup from "../../views/Signup/Signup";
import Chatbot from "../../views/Chatbot/Chatbot";
export class AdminRoutes extends Component {
  render() {
    return (
      <div>
      <Switch>
        //! ACTIVE ROUTES //! LIVE ROUTES
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/" component={Dashboard} />
        <Route exact path="/accountManagement" component={AccountManagement} />
        <Route exact path="/setting" component={Setting} />
        {/*  */}
        //! FOR TESTING (COMMENT OUT WHEN PUSHING TO LIVE)
        {/*  */}
        {/* <Route exact path="/setting" component={Setting} /> */}
        //! INACTIVE ROUTES
        {/* <Route exact path="/test" component={Test} /> */}
        {/* <Route exact path="/plans" component={Plans} /> */}
        {/* <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} /> */}
        {/* <Route exact path="/GroupSharing" component={GroupShare} />
        <Route exact path="/audittrailmapview" component={SimpleMap} />
        
        {/*  */}
        //!DO NOT COMMENT OUT - MUST BE LAST
        <Route component={PageNotFound} />
      </Switch>
      {/* <Chatbot/> */}
      </div>
    );
  }
}

export default AdminRoutes;
